import legalInfo from './legalInfo.json';
import { LOCALE_TAGS, STRINGS, fill, type Language } from './i18n';

export const getLegalEntityName = (): string => {
  return legalInfo.legalEntity.name;
};

export const getFullAddress = (): string => {
  return legalInfo.legalEntity.fullAddress;
};

export const getFormattedAddress = (): string => {
  const addr = legalInfo.legalEntity.address;
  return `${addr.street}, ${addr.city}, ${addr.state} ${addr.zip}, ${addr.country}`;
};

export const getSupportEmail = (): string => {
  return legalInfo.contact.supportEmail;
};

export const getSecurityEmail = (): string => {
  return legalInfo.contact.securityEmail;
};

// getResponseTime / getAvailability убраны 2026-10-17 (аудит сторов Б10, Р17): сроков ответа поддержки не обещаем.

// 'YYYY-MM-DD' парсим по компонентам: new Date(iso) даёт UTC-полночь, и у посетителя
// западнее UTC дата документа отображалась бы на день раньше (July 8 вместо July 9).
const parseLocalDate = (iso: string): Date => {
  const [y, m, d] = iso.split('-').map(Number);
  return new Date(y, m - 1, d);
};

const formatLegalDate = (iso: string, lang: Language): string => {
  const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };
  return parseLocalDate(iso).toLocaleDateString(LOCALE_TAGS[lang], options);
};

export const getLastUpdatedDate = (lang: Language): string =>
  formatLegalDate(legalInfo.dates.lastUpdated, lang);

export const getEffectiveDate = (lang: Language): string =>
  formatLegalDate(legalInfo.dates.effectiveDate, lang);

export const getDataController = (lang: Language): string => {
  const label = STRINGS[lang].legal.dataController;
  const legalEntity = getLegalEntityName();
  const fullAddress = getFullAddress();
  if (!fullAddress) return `${label}: ${legalEntity}`;
  return `${label}: ${legalEntity}, ${fullAddress}`;
};

export const getCopyright = (): string => {
  return `${legalInfo.copyright.year} ${legalInfo.copyright.holder}. All rights reserved.`;
};

export const getCopyrightTranslated = (lang: Language): string =>
  fill(STRINGS[lang].footer.copyright, { year: legalInfo.copyright.year, holder: legalInfo.copyright.holder });

export const getLegalInfo = () => legalInfo;
